import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://bgxknlqdexgfcwzmrgbh.supabase.co';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXAiLCJyZWYiOiJiZ3hrbmxxZGV4Z2ZjdzdtcmdiaCIsInJvbGUiOiJhbm9uIiwiaWF0IjoxNzc2MzkxMTg4LCJleHAiOjIwOTE5NjcxODh9.z1BEMzm-Jvn_nMl5wUyR1SCRM34WH7dyQFtHGAY1_Ek';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'sohlocal-auth-token',
    storage: window.localStorage,
    flowType: 'pkce'
  },
  global: {
    headers: { 'x-application-name': 'sohlocal' }
  }
});

export const checkConnection = async () => {
  try {
    const { data, error } = await supabase.from('users').select('id').limit(1).timeout(2000);
    if (error) throw error;
    return { ok: true, message: 'Connected' };
  } catch (err) {
    return { ok: false, message: err.message };
  }
};